import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { NotifierService } from "angular-notifier";
import { ActivatedRoute } from '@angular/router';
import { PostStripeService } from '../../services/post-stripe.service';
import { MixPanelService } from '../../services/mix-panel.service';
import { PostLogTransactionService } from '../../services/post-log-transaction.service';
import { SendFormContactService } from 'src/app/services/send-form-contact.service';
import { CheckService } from './checkout.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { environment } from 'src/environments/environment';
import { PostSlackStripeService } from 'src/app/services/post-slack-stripe.service';

declare const fbq: any;

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: false },
    },
  ]
})

export class CheckoutComponent implements OnInit {
  _env: string = this.env._env;

  fieldTextType: boolean = false;
  private readonly notifier: NotifierService;

  public firstFormGroup: FormGroup = new FormGroup({})
  public secondFormGroup: FormGroup = new FormGroup({})
  public signupForm: FormGroup = new FormGroup({})

  check_company: Promise<any> = null;
  checkCompany: Promise<any> = null;
  stepOneCompleted: boolean = true;
  stepTwoCompleted: boolean = false;
  stepThreeCompleted: boolean = false;
  titleLastStep: string = "Falta poco";
  textLastStep: string = "Procesando...";
  textSubtitleLastStep: string = "";
  textUser: string = "";
  textPaymentAmount = "";
  url_path: string = window.location.href;
  textLSMainMessage = "";
  textLSStripeMessage = "";
  LSCobrado = false;
  LSError = false;
  textLSUserName = ""
  textLSOnBoardingAgent = ""
  textLSOnBoardingEmail = ""
  textLSOnBoardingPhone = ""
  isMobile: any = false;
  isRetry: any = false;
  textRetrySecret: any = ""
  landing_record_id: any;

  //ThankYouPage
  shouldCelebrate: Boolean = false;
  pageTitle: string | undefined;
  pageSubtitle: string | undefined;
  showPendiente: boolean = false;
  showExitoso: boolean = false;
  showError: boolean = false;
  showLite: boolean = false;
  contactAgent: string | undefined;
  contactEmail: string | undefined;
  contactPhone: string | undefined;
  confettiInterval: any;
  processingPayment: boolean;


  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  @ViewChild('stepper')
  stepper: MatStepper;

  nextClick(): void {
    //this.stepper.linear = false;
    setTimeout(() => {
      this.stepper.selectedIndex = 4;
    });
    setTimeout(() => {
      this.stepper.linear = true;
    });
  }

  constructor(
    notifierService: NotifierService,
    private activatedRoute: ActivatedRoute,
    public PostStripe: PostStripeService,
    private mixpanelService: MixPanelService,
    public PostLogTransaction: PostLogTransactionService,
    private sendFormContact: SendFormContactService,
    private checkoutService: CheckService,
    private env: EnvironmentService,
    private postSlackStripe: PostSlackStripeService
  ) {
    this.notifier = notifierService;
  }

  async ngOnInit() {
    this.processingPayment = true;
    this.mobileCheck();
    let recurrence_msg = ""
    let testElements = Array.from(document.getElementsByClassName('mat-horizontal-stepper-header-container') as HTMLCollectionOf<HTMLElement>)
    testElements.forEach((element) => { element.style.pointerEvents = 'none'; });

    let stepperBars = Array.from(document.getElementsByClassName('mat-horizontal-stepper-header-container') as HTMLCollectionOf<HTMLElement>)
    stepperBars.forEach((stepperBar) => { if (this.isMobile) stepperBar.style.display = 'none'; });

    let matHorizontal = Array.from(document.getElementsByClassName('mat-horizontal-content-container') as HTMLCollectionOf<HTMLElement>)
    matHorizontal.forEach((matHzt) => { if (this.isMobile) matHzt.style.padding = '0'; });

    this.nextClick();
    this.activatedRoute.queryParams.subscribe(async params => {
      // SI EL ESTADO ES MICHOACAN ENTONCES
      if (params['michoacan'] == 'true') {
        this.validateMichoacanResponse(params);
        return null;
      }

      if (params['redirect_status'] == 'succeeded') {
        this.succedValidateRedirectStatus(params);
      } else {
        this.redirectStatusError();
      }
    });
  }

  private validateMichoacanResponse(params: any): void {
    console.log('NEW PARAMS', params)
    if (params['post_slack'] == 'true') {
      console.log('POST SLACK TRUE');
      this.checkoutService.addMixPanelEvent('LandingPaymentSuccess', { status: 'ok' });
      //fbq("trackCustom", "Thank You Page Contacto");
      //fbq("trackCustom", "VA Pago Exitoso");

      this.postStripeMichoacanSuccess(params);
    } else {
      this.postStripeMichoacanError(params);
    }
  }

  private postStripeMichoacanSuccess(params: any): void {
    this.checkoutService.addLogTransaction("success_payment", this.landing_record_id);
    this.sendMetaAPIEvent('API Thank You Page');

    this.assignThankYouVariables(
      "¡Te damos la bienvenida a Contalink!",
      "Tu cuenta ya está activa, hemos enviado un correo electrónico con tus datos de acceso",
      true,
      true,
      false
    );
    this.processingPayment = false;

    console.log('PARAMS', params);

    this.contactAgent = params['onboardingagent'];
    this.contactEmail = params['email'];
    this.contactPhone = params['phone'];

    this.confettiInterval = setInterval(() => {
      this.checkoutService.launchConfetti();
    }, 1000);
  }

  private postStripeMichoacanError(params: any): void {
    // Error de redirección
    console.log('Parametros en checkout payment',params);
    this.LSError = true
    this.assignThankYouVariables(
      params['errorTitle'],
      // "Favor de comunicarse con nuestro equipo vía info@contalink.com o por Whatsapp al +52 811 910 7569",
      params['errorSubtitle'],
      false,
      false,
      false
    );
    this.checkoutService.addLogTransaction("error_redirect_checkout", this.landing_record_id);
    this.checkoutService.addMixPanelEvent('LandingPaymentError', { status: 'error_stripe_form_redirect' });
    this.processingPayment = false;
  }

  private nodeDoesNotExists(): void {
    this.LSError = true;
    this.assignThankYouVariables(
      "Error",
      "Ha habido un error al procesar su pago. \nFavor de comunicarse con nuestro equipo vía info@contalink.com o por Whatsapp al +52 811 910 7569",
      false,
      false,
      false
    );

    this.checkoutService.addLogTransaction("error_payment_stripe_no_response", this.landing_record_id)
    this.checkoutService.addMixPanelEvent('LandingPaymentError', { status: 'error_stripe_not_stripe_node' });
  }

  private redirectStatusError(): void {
    // Error de redirección
    this.LSError = true
    this.assignThankYouVariables(
      "Error",
      "Ha habido un error al procesar su pago. \nFavor de comunicarse con nuestro equipo vía info@contalink.com o por Whatsapp al +52 811 910 7569",
      false,
      false,
      false
    );
    this.checkoutService.addLogTransaction("error_redirect_checkout", this.landing_record_id);
    this.checkoutService.addMixPanelEvent('LandingPaymentError', { status: 'error_stripe_form_redirect' });
  }

  private sendPostStripeError(): void {
    this.sendMetaAPIEvent('API Thank You Page');
    this.checkoutService.addLogTransaction("success_payment_suscription_error", this.landing_record_id);
    this.LSError = true
    this.assignThankYouVariables(
      "Ya casi, solo un paso más",
      "Tu pago ha sido procesado, pero hemos tenido un problema para activar tu cuenta",
      false,
      false,
      true
    );
  }

  private sendPostStripeSuccess(post_stripe: any): void {
    this.checkoutService.addLogTransaction("success_payment", this.landing_record_id);
    //this.sendMetaAPIEvent('API Thank You Page VA');

    this.assignThankYouVariables(
      "¡Te damos la bienvenida a Contalink!",
      "Gracias, hemos confirmado tu pago. Tu cuenta ya está activa, hemos enviado un correo electrónico con tus datos de acceso",
      true,
      true,
      false
    );
    this.contactAgent = post_stripe['deal']['onboarding_info']['onboardingagent'];
    this.contactEmail = post_stripe['deal']['onboarding_info']['email'];
    this.contactPhone = post_stripe['deal']['onboarding_info']['phone'];

    // POST SLACK_STRIPE_SLACK
    let post_slack: any = this.postSlackStripe.postContalinkSlackStripe(
      post_stripe['request']
    ).toPromise();

    this.confettiInterval = setInterval(() => {
      this.checkoutService.launchConfetti();
    }, 1000);
  }

  private async succedValidateRedirectStatus(params: any): Promise<void> {
    //fbq("trackCustom", "VA Intencion Pago");
    let data = {
      "uc_customer_stripe_id": params['setup_intent_client_secret'],
      "qa": this._env === "qa" ? true : false
    };
  
    let post_stripe: any = await this.PostStripe.postContalinkStripe(
      data
    ).toPromise()

    this.processingPayment = false;
    console.log("PostS>", post_stripe);
    this.landing_record_id = post_stripe['request']['record_landing_id']
    this.checkoutService.addLogTransaction("processed_payment", this.landing_record_id);

    if (post_stripe.hasOwnProperty('stripe-retry')) {
      this.textRetrySecret = post_stripe['stripe-retry']['stripe_clientsecret_id'];
    }

    if ("stripe" in post_stripe) {
      this.containsStripeInPostStripeVariable(post_stripe);
    } else {
      this.nodeDoesNotExists();
    }
  }

  private containsStripeInPostStripeVariable(post_stripe: any): void {
    let mierror = localStorage.getItem('error_de_timbrado');
    let redirect_url = ""

    if (post_stripe['stripe']['status'] == 1) {
      this.checkoutService.addMixPanelEvent('LandingPaymentSuccess', { status: 'ok' });
      //fbq("trackCustom", "Thank You Page Contacto");
      //fbq("trackCustom", "VA Pago Exitoso");
      if (post_stripe['error']) {
        this.sendPostStripeError();
      } else {
        this.sendPostStripeSuccess(post_stripe);
      }
    } else {
      this.postStripeStatusIsNotEqualToOne(post_stripe);
    }
  }

  private postStripeStatusIsNotEqualToOne(post_stripe: any): void {
    this.isRetry = true;
    this.LSError = true;

    let subtitleError = "Algo ha salido mal con tu pago";
    this.checkoutService.addMixPanelEvent('LandingPaymentError', { status: 'error_stripe_status_not_zero_retry' });

    if (post_stripe['stripe']['message']) {
      this.checkoutService.addLogTransaction("error_payment " + post_stripe['stripe']['message'], this.landing_record_id);
      subtitleError += " (" + post_stripe['stripe']['message'] + ") ";
    }
    this.assignThankYouVariables("Error", subtitleError, false, false, false);
  }

  private sendMetaAPIEvent(event_name: string) {
    let $api: Observable<any> = this.sendFormContact.sendIntegrationAPI(event_name)

    $api.subscribe((res) => { })
  }

  private assignThankYouVariables(pageTitle, pageSubtitle, shouldCelebrate, showExitoso, showError) {
    this.pageTitle = pageTitle;
    this.pageSubtitle = pageSubtitle;
    this.shouldCelebrate = shouldCelebrate;
    this.showExitoso = showExitoso;
    this.showError = showError;
  }

  private mobileCheck() {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent);
    this.isMobile = check;
  }
}